<template>
  <v-select
    :label="label"
    :items="items"
    @change="$emit('change', $event)"
    @click:append="$emit('clickappend')"
    v-bind="$attrs"
  ></v-select>
</template>

<script>
export default {
  name: 'Select',
  props: {
    label: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: () => []
    }
  }
}
</script>